import { FeatureSwitches } from '../../../constants/feature-switches';
export var redirectToSearchResultsPage = function (searchItem, navigate) {
    var searchParams = new URLSearchParams({ search: searchItem });
    navigate("/myaccount/purchase-history/search-results?".concat(searchParams.toString()));
};
export var makeSearchRequestBody = function (searchItem, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
thdCustomerInfo, orderHistoryData, orderHistoryInfo, pageNumber, searchItems) {
    var _a, _b, _c;
    var modifiedSearchItem = searchItem.trimStart();
    var searchResultMetadata = null;
    if (pageNumber > 1) {
        var meta = (_a = searchItems === null || searchItems === void 0 ? void 0 : searchItems.searchResultMetadata) !== null && _a !== void 0 ? _a : {};
        searchResultMetadata = {
            orderPosition: meta.orderPosition,
            itemPosition: meta.itemPosition,
            lastItemOfLastOrder: meta.lastItemOfLastOrder,
        };
    }
    return {
        purchaseSearchRequest: {
            customerAccountId: thdCustomerInfo === null || thdCustomerInfo === void 0 ? void 0 : thdCustomerInfo.svocID,
            endDate: null,
            pageNumber: pageNumber === null || pageNumber === void 0 ? void 0 : pageNumber.toString(),
            pageSize: '20',
            purchaserId: (_c = (_b = orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.userId) !== null && _b !== void 0 ? _b : orderHistoryInfo === null || orderHistoryInfo === void 0 ? void 0 : orderHistoryInfo.userId) !== null && _c !== void 0 ? _c : '',
            search: modifiedSearchItem || '',
            startDate: null,
            searchResultMetadata: searchResultMetadata,
        },
    };
};
export var getPlaceholderValue = function (isMobile) {
    if (FeatureSwitches.enableCPSAnnouncementBanner) {
        return 'Search';
    }
    if (isMobile) {
        return 'Search by item description';
    }
    return 'Search by item description, order number or PO/job name';
};
